import CryptoJS from 'crypto-js';

/**
 *
 * @param salt your secret key
 * @param text string
 * @returns return string
 */

const encrypt = (salt, text) => {
    const textToChars = (text) => text.split('').map((c) => c.charCodeAt(0));
    const byteHex = (n) => ('0' + Number(n).toString(16)).substr(-2);
    const applySaltToChar = (code) =>
        textToChars(salt).reduce((a, b) => a ^ b, code);

    return text
        .split('')
        .map(textToChars)
        .map(applySaltToChar)
        .map(byteHex)
        .join('');
};

/**
 *
 * @param salt your secret key
 * @param encoded encrypted code
 * @returns return string
 */

const decrypt = (salt, encoded) => {
    const textToChars = (text) => text.split('').map((c) => c.charCodeAt(0));
    const applySaltToChar = (code) =>
        textToChars(salt).reduce((a, b) => a ^ b, code);
    return encoded
        .match(/.{1,2}/g)
        .map((hex) => parseInt(hex, 16))
        .map(applySaltToChar)
        .map((charCode) => String.fromCharCode(charCode))
        .join('');
};

// Function to encrypt data using AES-CBC
const encryptData = (accessToken, step) => {
    let encryptedData = accessToken;

    if((process.env.NEXT_PUBLIC_CUSLOC_ENABLE === "true" && step === "customerNumber") || ["step1", "step2", "login", "cardToken", "appointmentScheduler"].includes(step) ){
        const encryptKey = getKeyByStep(step);
        const key = CryptoJS.enc.Utf8.parse(encryptKey);
        const IV = CryptoJS.enc.Utf8.parse(encryptKey.substring(0, 16));

        const encrypted = CryptoJS.AES.encrypt(accessToken, key, {iv: IV}); // apply default: CBC and PKCS#7 padding
        encryptedData = encrypted.toString();
    }
    return encryptedData;
};

// Function to decrypt encrypted data
const decryptData = (encryptedData, step) => {

    const decryptKey = getKeyByStep(step);

    const key = CryptoJS.enc.Utf8.parse(decryptKey);
    const IV = CryptoJS.enc.Utf8.parse(decryptKey.substring(0, 16));
    
    const decrypted = CryptoJS.AES.decrypt(encryptedData, key, {iv: IV}); // apply default: CBC and PKCS#7 padding
    const decryptedData = decrypted.toString(CryptoJS.enc.Utf8);
    
    return decryptedData;
};

const getKeyByStep = (step) => {
    let key;
    switch (step) {
        case "appointmentScheduler": key = process.env.REACT_APP_PUBLIC_APPSCH; break;
        default: key= ""; break;
    }
    return key;
}
export { encrypt, decrypt, encryptData, decryptData};